import React from "react";
import styled from "styled-components";

export default styled.div`
    text-decoration: none;
    text-align: center;
    font-size: 12px;
    margin-bottom: 20px;
    display: block;
    color: #515151;
    cursor: pointer;
    width: 80px;
    height: 63px;
    margin: 0 auto;
    position: relative;
    // margin-bottom: 15px;
    // margin-top: 15px;
    // max-height: 6vh !important;
    display: ${(props) => (props.hidden ? "none" : "block")};
    
    &:hover {
        background: #F1F4F9
    }
    
    &.end-lesson-icon:hover {
        background: #38428c;
    }
    
    &.end-lesson-icon {
        background: #5562c0 !important;
    filter: none;
    }
    
    ${(props) => (props.open ? {
    'background': '#5562C0 !important',
} : '')}


    ${(props) => (props.active ? '' : {
    'filter' : 'grayscale(1)',
    // 'background' : '#e5e5e5',
})}


    ${(props) => (props.layout ? {
    
} : '')}


    ${(props) => (props.button ? {
    'background': '#5562C0',
    'color': 'white',
    'padding': '8px 5px',
    'width': '90%',
    'border-radius': '5px',
    'height': 'auto',
    'font-size': '11px',
} : '')}

    @media(max-height: 454px) {
        margin: 0 auto;
    }
`;

